<template>
  <section :class="$style.edit">
    <div :class="[$style.edit__form, $style.form]">
      <DolphinTextInput
        v-model="editingTemplate.label"
        placeholder="タイトル"
        :class="$style.edit__input"
      />
      <DolphinTextarea
        v-model="editingTemplate.body"
        :placeholder="TEXTAREA_PLACEHOLDER"
        :class="$style.edit__textarea"
      />
      <MessageAttachmentActions
        v-model="editingTemplate.selections"
        :class="$style.edit__selection"
      />
    </div>
    <div :class="$style.edit__buttonSection">
      <FlatButton
        variant="secondary"
        :class="[$style.buttonSection__cancel]"
        @click="emit('cancel')"
      >
        キャンセル
      </FlatButton>
      <FlatButton
        variant="primary"
        :class="[$style.buttonSection__save]"
        :disabled="!isValid"
        @click="emit('save')"
      >
        保存
      </FlatButton>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import DolphinTextInput from '@/components/atoms/DolphinTextInput.vue'
import DolphinTextarea from '@/components/atoms/DolphinTextarea.vue'
import MessageAttachmentActions from '@/components/organisms/MessageAttachmentActions/MessageAttachmentActions.vue'
import type { ChatMessageTemplate } from '@/types/app'
import FlatButton from '@/components/atoms/FlatButton.vue'

const TEXTAREA_PLACEHOLDER = `テンプレートの本文を入力してください。

例）
ご連絡いただきありがとうございます。
宜しければ以下のリンクから日程調整をさせていただければと思います。

【日程調整】
リンク
`

const props = defineProps<{
  modelValue: ChatMessageTemplate
}>()

const emit = defineEmits<{
  (event: 'update:modelValue', payload: ChatMessageTemplate): void
  (event: 'save'): void
  (event: 'cancel'): void
}>()

const editingTemplate = computed({
  get() {
    return props.modelValue
  },
  set(value: ChatMessageTemplate) {
    emit('update:modelValue', value)
  },
})

const isValid = computed(
  () => editingTemplate.value.label !== '' && editingTemplate.value.body !== ''
)
</script>
<style lang="scss" module>
.edit {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__input {
    font-size: 14px;
  }

  &__form {
    overflow-y: scroll;
    flex: 1;
  }

  &__textarea {
    font-size: 14px;
    min-height: 260px;
  }

  &__buttonSection {
    border-top: 1px $color-border-low-emphasis solid;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }
}

.form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
